// Buildconfiguration
// THIS FILE WILL BE GENERATE AUTOMATICLY BY tools/get_server_data.ts
export const buildConfig = {
  /** YourApp Server get at Date */
  created_at_ymd: 20190101,
  /** YourApp Server get at Time */
  created_at_hms: 0,
};
